import * as React from 'react';
import { SVGIconRender } from './SVGIconRender';

interface IconProps {
  color?: string;
  size?: string;
  bgFillColor?: string;
}

const TicketModule = ({ color = 'black', bgFillColor = 'black', size = 'md' }: IconProps) => {
  return (
    <SVGIconRender
          size={size}
          color={color}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3 6.30244C3 5.47256 3.67275 4.7998 4.50264 4.7998H19.4974C20.3272 4.7998 21 5.47256 21 6.30244V8.39073C21 9.02757 20.5659 9.56724 20.0929 9.99363C19.5446 10.4878 19.2 11.2035 19.2 11.9997C19.2 12.7959 19.5446 13.5116 20.0929 14.0058C20.5659 14.4322 21 14.9718 21 15.6087V17.6972C21 18.5271 20.3272 19.1998 19.4974 19.1998H4.50264C3.67275 19.1998 3 18.5271 3 17.6972V15.6087C3 14.9719 3.43411 14.4322 3.90713 14.0058C4.45536 13.5116 4.79999 12.7959 4.79999 11.9997C4.79999 11.2035 4.45536 10.4878 3.90713 9.99363C3.43411 9.56723 3 9.02756 3 8.39072V6.30244Z"
            fill="url(#paint0_linear_294_15836)"
          />
          <rect
            x="7.5"
            y="8.8501"
            width="9"
            height="0.9"
            rx="0.45"
            fill="#7B130E"
          />
          <rect
            x="7.5"
            y="11.5498"
            width="9"
            height="0.9"
            rx="0.45"
            fill="#7B130E"
          />
          <rect
            x="7.5"
            y="14.25"
            width="6.3"
            height="0.9"
            rx="0.45"
            fill="#7B130E"
          />
          <defs>
            <linearGradient
              id="paint0_linear_294_15836"
              x1="12"
              y1="4.7998"
              x2="12"
              y2="19.1998"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#FE786D" />
              <stop offset="1" stop-color="#F2AAFF" />
            </linearGradient>
          </defs>
        </SVGIconRender>
  );
};

export default TicketModule;
